import React from 'react';

import { ModalConditionsComponent } from './ModalConditionsComponent';
import { ModalMultiDiscountComponent } from './ModalMultiDiscountComponent';

import './ModalMetaDataComponent.scss';

export const ModalMetaDataComponent = ({ i18n, REFUND, partner, coupon, discounts }) => (
    <section className="interstitiel-modal-metadata">
        <p className="bold">{i18n.CONDITIONS_TITLE}</p>
        <div className="grid-2 has-gutter">
            <ModalConditionsComponent partner={partner} coupon={coupon} i18n={i18n} />
            <ModalMultiDiscountComponent partner={partner} discounts={discounts} REFUND={REFUND} />
        </div>
    </section>
);



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/metadata/ModalMetaDataComponent.js